import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { createPortal } from 'react-dom'

import { fromJS } from 'immutable'

import TutorialVideoList from '@aytm/lib/rfd-ui/components/advanced/tutorial-video-list'

import StickyHeader from '@aytm/app/stats/page/components/StickyHeader'
import { KBarSpecialButton } from '@aytm/lib/kbar'
import style from '@aytm/app/stats/page/components/styles/ContentHeader.module.scss'

export const StatTutorialVideo = fromJS({
  video: {
    id: 'statistics',
    title: 'Tutorial video',
    length: '8:05',
    autoplay: false,
    code: '501928393',
    url: 'https://player.vimeo.com/video/'
  },
  videoPoints: [
    { time: 0, text: 'Finding your Results page' },
    { time: 27, text: 'Original - as fielded Report' },
    { time: 79, text: 'General analysis tools' },
    { time: 181, text: 'Survey Specifications & Reports' },
    { time: 226, text: 'View Options & Filters' },
    { time: 305, text: 'Data Lab & Data Weighting' },
    { time: 335, text: 'Crosstab & Attachments' },
    { time: 366, text: 'Color Options & Exports' },
    { time: 453, text: 'Blog Widget & Print options' }
  ],
  videoNote: "Learn about aytm's interactive survey results, report, and data analysis tools.",
  videoThumbnail: '/images/tvs/statistics.jpg'
})

const ContentHeader = ({ mode, state, surveyTitle, report, customization, isReportXpert, ...props }) => {
  const stickyHeaderContainer = useMemo(() => document.querySelector(`#${state.replaceAll('-', '_')}_content`), [state])

  return (
    <>
      {isReportXpert ? (
        <div className={style['survey-title-xpert']}>
          <div className={style['survey-title-xpert-icon']}>
            <i className="icon-aytmfd-xpert-solution-v2" />
          </div>
          <div className={style['survey-title-xpert-text']}>
            <div className={style['survey-title-xpert-text-title']}>
              <b>aytm Xpert</b>&nbsp;
              <span
                dangerouslySetInnerHTML={{ __html: customization.find(v => 'Title' == v.title)?.value || '' }}
              ></span>
            </div>
            <div className={style['survey-title-report-text-report-title']}>
              <b>REPORT:</b>&nbsp;<span dangerouslySetInnerHTML={{ __html: report.title || 'Xpert Report' }}></span>
            </div>
          </div>
        </div>
      ) : (
        <div className={style['survey-container']}>
          <div className={style['survey-title']}>
            <span dangerouslySetInnerHTML={{ __html: surveyTitle }}></span>
            <div
              className={`${'charts' == state ? `${style.commandBar} ` : `${style.commandBarStatic} `}${
                style.commandBarContainer
              }`}
            >
              <KBarSpecialButton />
            </div>
          </div>

          {'charts' == state ? (
            <TutorialVideoList
              className={style.tutorialVideoList}
              video={StatTutorialVideo.get('video')}
              videoNote={StatTutorialVideo.get('videoNote')}
              videoPoints={StatTutorialVideo.get('videoPoints')}
              videoThumbnail={StatTutorialVideo.get('videoThumbnail')}
              targetClassName="pendo-help-stat-vid"
              hiddenText={true}
            />
          ) : null}
        </div>
      )}

      {stickyHeaderContainer
        ? createPortal(
            <StickyHeader mode={mode} state={state} isReportXpert={isReportXpert} {...props} />,
            stickyHeaderContainer
          )
        : null}
    </>
  )
}

ContentHeader.propTypes = {
  url: PropTypes.string,
  mode: PropTypes.string,
  state: PropTypes.string,
  surveyId: PropTypes.number,
  surveyTitle: PropTypes.string,
  surveyStatus: PropTypes.string,
  surveyCompleted: PropTypes.string,
  report: PropTypes.object,
  customization: PropTypes.array,
  totals: PropTypes.object,
  controls: PropTypes.object,
  isSurveyGuest: PropTypes.bool,
  isSurveyViewer: PropTypes.bool,
  isReportLoading: PropTypes.bool,
  isReportVirtual: PropTypes.bool,
  isReportXpert: PropTypes.bool,
  onFetch: PropTypes.func,
  onModeChange: PropTypes.func,
  onShowReportPopup: PropTypes.func
}

ContentHeader.displayName = 'ContentHeader'

export default ContentHeader
